
dybHelpIcon = ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'forms/helpIcon'
    transclude: true
    scope:
        helpText: '='

    link: (scope, element, attrs, ctrl, translude) ->
        scope.hasTransclude = false

        translude (tElement, tScope) ->
            Object.defineProperty scope, 'hasTransclude',
                get: -> tElement?.length > 0 and tElement.text()
                configurable: true


module.directive('dybHelpIcon', dybHelpIcon)